// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__1_XaI","name":"Details_name__3U66W","stats":"Details_stats__2PzqK","statBox":"Details_statBox__3Jf5F"};